//Firebase
import firebase from 'firebase';


export type Ref = firebase.database.DataSnapshot;


export enum DataBaseNodes {
    private_messages = 'private_messages',
    public_messages = 'public_messages',
}